import { EnumMapper } from "../../../common/tables/etc/EnumMapper";
import { ShopifyProductForAdmin } from "../../../../../common/tables/shopify/ShopifyProductForAdmin";
import { EnumResolver } from "../../../common/tables/etc/EnumResolver";

export class ShopifyProductEnumResolver extends EnumResolver<ShopifyProductForAdmin> {
    public resolveEnum(_columnName: keyof ShopifyProductForAdmin): EnumMapper {
        // ShopifyProduct has no badge/select enum columns of its own — storeName,
        // its only singleSelect, is rendered by a dedicated store-search renderer
        // in ShopifyProductTableCellFactory and never reaches here. Return an
        // EnumMapper whose map() is empty (not a bare {}) so EnumResolver.resolve()
        // degrades to [] instead of throwing "resolveEnum(...).map is not a
        // function" if some other column is ever routed here (e.g. a stale
        // persisted table config hydrated after a CellType change).
        return { map: () => ({}) };
    }
}
